import { render } from "./Detection.vue?vue&type=template&id=6d1eb1e0&scoped=true"
import script from "./Detection.vue?vue&type=script&lang=js"
export * from "./Detection.vue?vue&type=script&lang=js"

import "./Detection.vue?vue&type=style&index=0&id=6d1eb1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1eb1e0"]])

export default __exports__